<template>
    <div class="p-12 container">
        <div class="row">

            <div class="col">

                <h2>Dedicated Servers</h2>

                <ul class="breadcrumb bg-grey-100 rounded p-4 mb-8">
                    <li class="breadcrumb-item"><router-link to="/order">Order</router-link></li>
                    <li class="breadcrumb-item active">Dedicated Servers</li>
                </ul>

                <vdc-alert>
                    <template v-slot:features>
                        <ul>
                            <li>High availability dual-zone platform</li>
                            <li>Scales with your business</li>
                            <li>Powerful networking options</li>
                            <li>Support for custom images</li>
                            <li>Self Service Backups with support for ransomware protected immutable backups</li>
                            <li>Multiple Tiers of Storage - NVMe, SSD, &amp; Hybrid</li>
                            <li>Servers Australia holds the highest certification levels as a VMware Principle Partner &amp; VMware Cloud Verified Provider</li>
                        </ul>
                    </template>
                </vdc-alert>

                <div style="height: 100px; background-image: url('data:image/svg+xml;base64,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'); background-repeat: no-repeat; background-position: center center;"></div>
                <h3 class="text-2xl text-center m-1 mb-3 p-0">Enterprise Series</h3>
                <p>
                    The Enterprise Series are powered by HPE Gen11 servers, designed for your mission critical workloads built on highly reliable, enterprise grade hardware. Perfect for virtualisation, databases, and other high-performance and reliable computing.
                </p>
                <div class="flex flex-wrap xl:px-2">
                    <div class="w-full sm:w-1/2 lg:w-1/3 flex items-stretch" v-for="(server, index) in enterpriseSeries" :key="index">
                        <div class="m-1 w-full self-stretch">
                            <div class="border h-full relative">
                                <div class="h-full self-stretch justify-center m-0">
                                    <div class="flex flex-col h-full">
                                        <div class="flex items-center relative" style="padding-top: 41%;">
                                            <div class="block w-full text-grey-900 text-3xl text-center sau-font-bold absolute h-12 -mt-6" style="top: 50%;">
                                                {{ server.name }} <span class="text-grey-100 inline-block text-center rounded-lg rounded-br-none w-12 h-12" :class="server.class">{{ server.version }}</span>
                                            </div>
                                        </div>
                                        <div class="px-8">
                                            <p class="text-center mb-0 border-b py-2">{{ server.cpu }}</p>
                                            <p class="text-center mb-0 border-b py-2"><strong class="sau-font-bold">{{ server.core_count }}</strong> {{ server.core_details }}</p>
                                            <p class="text-center mb-0 border-b py-2">{{ server.ram }}</p>
                                            <p class="text-center mb-0 border-b py-2" v-html="server.storage"></p>
                                            <p class="text-center mb-8 pt-2">{{ server.bandwidth }}</p>
                                        </div>

                                        <div class="mt-auto text-center px-8 pb-8">
                                            <p class="sau-font text-xs mb-0">Per Month* Ex. GST</p>
                                            <p class="sau-font-bold text-green text-2xl mb-2">{{ server.price }}</p>
                                            <button
                                                type="button"
                                                class="btn btn-success btn-sm w-3/4"
                                                @click="selectViaHash(server.hash)"
                                            >
                                                Select
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p><small>* Minimum contract period of 36 months applies to Enterprise Series servers.</small></p>


                <div class="mt-12" style="height: 100px; background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMjcuMDIgMTM1LjgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEyNy4wMiAxMzUuODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNFQzc2MjM7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjUuODMsMTE4LjM4YzAsMCwyLjg2LDYuODUsOC4yNSwxMy4zMmwwLjIxLTAuNDVjLTQuNS03LjM4LTEyLjgxLTI3LjI4LDcuNzItNTIuNTJjMCwwLTUuMzgsMTEuODUsMS45LDIzLjQ1CgljMCwwLTEuNDctNDEuNzQsMjkuMDQtNTUuMTFjMCwwLTExLjg1LDE1LjA1LDQuNzgsMzQuMThjMCwwLDEzLjk4LDEyLjE2LDExLjU2LDM0LjQyYzIuODEtNC43OSw1LjY3LTExLjkzLDQuMzItMTkuODMKCWMwLDAsMTEuNTEsMTcuNTQsMi4xOCwzNy40NGgyOS4yNkw2My45MSwzLjE2TDIuNzksMTMzLjI2aDI1LjI3QzI2LjcxLDEyOC45NSwyNS44NywxMjQuMDQsMjUuODMsMTE4LjM4eiIvPgo8L3N2Zz4K'); background-repeat: no-repeat; background-position: center center;"></div>
                <h3 class="text-2xl text-center m-1 mb-3 p-0">BLAZE Series</h3>
                <p>
                    The BLAZE Series unleashes the power of the Intel Xeon processors. With blazing clock speeds and high speed NVMe storage, the BLAZE series is perfect for the situations where you need raw grunt.
                </p>
                <div class="flex flex-wrap xl:px-2">
                    <div class="w-full sm:w-1/2 lg:w-1/3 flex items-stretch" v-for="(server, index) in blazeSeries" :key="index">
                        <div class="m-1 w-full self-stretch">
                            <div class="border h-full relative">
                                <div class="h-full self-stretch justify-center m-0">
                                    <div class="flex flex-col h-full">
                                        <div class="flex items-center relative" style="background-size: cover; padding-top: 41%;">
                                            <div class="block w-full text-grey-900 text-3xl text-center sau-font-bold absolute h-12 -mt-6" style="top: 50%;">
                                                {{ server.name }} <span class="text-grey-100 inline-block text-center rounded-lg rounded-br-none w-12 h-12" :class="server.class">{{ server.version }}</span>
                                            </div>
                                        </div>
                                        <div class="px-8">
                                            <p class="text-center mb-0 border-b pb-2">{{ server.location }}</p>
                                            <p class="text-center mb-0 border-b py-2">{{ server.cpu }}</p>
                                            <p class="text-center mb-0 border-b py-2"><strong class="sau-font-bold">{{ server.core_count }}</strong> {{ server.core_details }}</p>
                                            <p class="text-center mb-0 border-b py-2">{{ server.ram }}</p>
                                            <p class="text-center mb-0 border-b py-2">{{ server.storage }}</p>
                                            <p class="text-center mb-8 pt-2">{{ server.bandwidth }}</p>
                                        </div>

                                        <div class="mt-auto text-center px-8 pb-8">
                                            <p class="sau-font text-xs mb-0">Per Month Ex. GST</p>
                                            <p class="sau-font-bold text-green text-2xl mb-2">{{ server.price }}</p>
                                            <button
                                                type="button"
                                                class="btn btn-success btn-sm w-3/4"
                                                @click="selectViaHash(server.hash)"
                                            >
                                                Select
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="my-6 p-6 bg-primary-100 w-full text-blue-800 shadow-lg border border-blue-300 flex md:flex-row justify-between items-center flex-col gap-4 md:gap-0">
                    <div>
                        <h4 class="font-bold text-blue-600">Not sure what best suits your business?</h4>
                        <p class="mb-0 text-blue-600">Contact our Sales team to discuss a solution tailored to suit your specific workloads.</p>
                    </div>
                    <div class="hover:bg-blue-200 border border-blue-600">
                        <button @click="launchIntercom" class="block no-underline py-2 px-3 text-blue-600">Contact Sales</button>
                    </div>
                </div>

                <h3 class="text-2xl text-center m-0 p-0 mb-12 mt-20">Value Server Range</h3>

                <div class="flex flex-wrap -m-4">
                    <div v-for="dedi in dedis" :key="dedi.id" class="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 flex items-stretch">
                        <div class="m-4 w-full self-stretch">
                            <div class="sau-bx-link h-full relative">
                                <div v-if="dedi.discount" class="w-32 h-32 top-0 right-0 absolute text-right overflow-hidden">
                                    <span
                                        style="line-height: 2rem; transform: rotate(45deg);"
                                        class="h-8 w-32 mt-4 -mr-8 block top-0 right-0 bg-red text-2xs absolute uppercase text-center sau-font-bold tracking-wide text-red-100"
                                    >
                                        {{ parseInt((dedi.discount / dedi.rrp) * 100) }}% OFF
                                    </span>
                                </div>
                                <div class="sau-bx h-full self-stretch justify-center border m-0 p-8">
                                    <div class="text-center flex flex-col h-full">
                                        <i class="fal fa-server block mb-4 text-5xl mx-auto"></i>
                                        <p class="mb-1">
                                            {{ dedi.cpu.description }}
                                        </p>
                                        <p class="mb-1">
                                            {{ dedi.ram.description }}
                                        </p>
                                        <p class="mb-1">
                                            <span v-for="(disk, key) in dedi.storage" :key="key" class="block">
                                                {{ `${disk.description} (${disk.storage_type})`  }}
                                            </span>
                                        </p>
                                        <p class="mb-1">
                                            {{ dedi.raid_card ? 'Hardware RAID' : 'Software RAID'  }}
                                        </p>
                                        <p class="mb-4">
                                            {{ dedi.location.name }}
                                        </p>
                                        <div class="mt-auto">
                                            <p class="sau-font text-xs mb-0">Per Month Ex. GST</p>
                                            <p class="sau-font-bold text-red text-xs mb-0" v-if="dedi.discount">Was {{ dedi.rrp | currency }}</p>
                                            <p class="sau-font-bold text-green text-2xl mb-2">{{ dedi.price | currency }}</p>
                                            <button
                                                type="button"
                                                class="btn btn-success btn-sm w-3/4"
                                                @click.prevent="selectServer(dedi)"
                                            >
                                                Select
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrderSummary from './Summary';
import VdcAlert from "@js/components/order/partials/VdcAlert";
import SauTable from "@js/components/utilities/SauTable";

export default {
    components: {
        OrderSummary,
        VdcAlert,
        SauTable
    },

    props: {
        data: Object,
        featuredServerHashes: Array,
    },

    data: function () {
        return {
            dedis: [],
            processing: false,
            type: 'dedicated-server',
            enterpriseSeries: [
                {
                    class: 'sau-enterprise',
                    name: 'Enterprise',
                    version: '16',
                    location: 'Sydney',
                    cpu: 'AMD EPYC 9135',
                    core_count: '16',
                    core_details: 'Cores 32 HT Cores @ 3.65Ghz with 4.3Ghz Boost',
                    ram: '128GB DDR4 ECC Memory',
                    storage: '2 x 480GB RAID 1 SSD (OS) <br>2 x 1.92TB Enterprise NVMe RAID 1 (Data) - 1.1M IOPS',
                    bandwidth: '7TB @ 10/25 Gbe Network Ports',
                    price: '$699',
                    hash: 'MTUyMDoxMzgzOjEwMzQ6MTQzMzo0MjY1'
                },
                {
                    class: 'sau-enterprise',
                    name: 'Enterprise',
                    version: '24',
                    location: 'Sydney',
                    cpu: 'AMD EPYC 9255',
                    core_count: '24',
                    core_details: 'Cores 48 HT Cores @ 3.825Ghz with 4.4Ghz Boost',
                    ram: '256GB DDR4 ECC Memory',
                    storage: '2 x 480GB RAID 1 SSD (OS)<br>2 x 3.84TB Enterprise NVMe RAID 1 (Data) - 1.1M IOPS',
                    bandwidth: '7TB @ 10/25 Gbe Network Ports',
                    price: '$949',
                    hash: 'NTQ1OToxNjYxOjEwMzQ6MTQzMzo0MTYx',
                },
                {
                    class: 'sau-enterprise',
                    name: 'Enterprise',
                    version: '32',
                    location: 'Sydney',
                    cpu: 'AMD EPYC 9355P',
                    core_count: '32',
                    core_details: 'Cores 64 HT Cores @ 2.9Ghz with 4.2Ghz Boost',
                    ram: '256 DDR4 ECC Memory',
                    storage: '2 x 480GB RAID 1 SSD (OS)<br>2 x 3.84TB Enterprise NVMe RAID 1 (Data) - 1.1M IOPS',
                    bandwidth: '7TB @ 10/25 Gbe Network Ports',
                    price: '$1199',
                    hash: 'MTk5MjoxNjYxOjEwMzQ6MTQzMzo0MTYx',
                },
            ],
            blazeSeries: [
                 {
                    class: 'sau-blaze-orange',
                    name: 'Blaze',
                    version: '4',
                    location: 'Sydney',
                    cpu: 'Intel Xeon E-2374G',
                    core_count: '4',
                    core_details: 'Cores 8 HT Cores @ 3.7Ghz with 5.1Ghz Boost',
                    ram: '32GB DDR4 ECC Memory',
                    storage: '2 x 480GB Enterprise NVMe 100,000 IOPS',
                    bandwidth: '7TB @ 2x 10Gbe Network Ports',
                    price: '$299',
                    hash: this.featuredServerHashes[0],
                },
                {
                    class: 'sau-blaze-orange',
                    name: 'Blaze',
                    version: '6',
                    location: 'Sydney',
                    cpu: 'Intel Xeon E-2386G',
                    core_count: '6',
                    core_details: 'Cores 12 HT Cores @ 3.5Ghz with 5.1Ghz Boost',
                    ram: '64GB DDR4 ECC Memory',
                    storage: '2 x 960GB Enterprise NVMe 100,000 IOPS',
                    bandwidth: '7TB @ 2x 10Gbe Network Ports',
                    price: '$349',
                    hash: this.featuredServerHashes[1],
                },
                {
                    class: 'sau-blaze-blue',
                    name: 'Blaze',
                    version: '8',
                    location: 'Sydney',
                    cpu: 'Intel Xeon E-2388G',
                    core_count: '8',
                    core_details: 'Cores 16 HT Cores @ 3.2Ghz with 5.1Ghz Boost',
                    ram: '64GB DDR4 ECC Memory',
                    storage: '2 x 1.92TB Enterprise NVMe 100,000 IOPS',
                    bandwidth: '7TB @ 2x 10Gbe Network Ports',
                    price: '$399',
                    hash: this.featuredServerHashes[2],
                }
            ]
        };
    },

    created() {
        this.dedis = this.data.config.products.rtg;
    },

    methods: {
        selectServer: function (server) {
            // Prevent duplicate entries
            if (this.processing) {
                return false;
            }

            // Flag as processing
            this.processing = true;

            // Loop over storage sets to format the object
            let storage = [];
            server.storage.forEach((disk, key) => {
                storage.push({
                    id: disk.id,
                    set: `storage_set${parseInt(key) + parseInt(1)}`,
                    raidType: ''
                });
            });

            // Create the object to pre select server options
            let config = {
                rtg: true,
                custom: false,
                cpu: server.cpu.id,
                ram: server.ram.id,
                location: server.location.id,
                storage: JSON.stringify(storage),
                grandfathered: server.grandfathered,
                raid_card: server.raid_card
            }

            window.bus.$once('order.items.created', response => {
                window.bus.$emit('order.items.update', this.type, response.data.slug, config);
            });

            window.bus.$once('order.items.updated', response => {
                this.processing = false;
                this.data.active.dedicatedServer = response.data.slug;
                this.$router.push('/order/dedicated-server/custom');
            });

            window.bus.$emit('order.items.create', this.type);
        },

        selectViaHash(hardwareHash, customise = false) {
            window.bus.$emit('order.items.addServerToOrderViaHash', hardwareHash, customise);
        },

        launchIntercom() {
            window.Intercom('showNewMessage', 'I\'d like to discuss a dedicated server solution.')
        }
    },
}
</script>

<style lang="scss">
    .sau-bx-link .ribbon {
        right: -9px;
    }
    .sau-bx-link sau-bx p.discount {
        text-decoration: line-through;
        color: #d8534f;
    }
    .sau-blaze-blue {
        background-color: #196AB4;
    }
    .sau-blaze-orange {
        background-color: #EC7623;
    }
    .sau-enterprise {
        background-color: #00ce7d;
    }

</style>
